<template>
  <v-chart :options="chartOptions" :autoresize="true" class="heatmap-chart" :style="{ height: height + 'px' }" />
</template>

<script>
import ECharts from "vue-echarts/dist/vue-echarts.js";
import "echarts/lib/chart/heatmap";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/grid";
import "echarts/lib/component/visualMap";

const DAY_ORDER = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const HOURS = Array.from({ length: 24 }, (_, i) => i);

export default {
  name: "HeatmapChart",
  components: {
    "v-chart": ECharts
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    height: {
      type: Number,
      default: 280
    }
  },
  computed: {
    chartOptions() {
      const max = this.data.reduce((m, d) => Math.max(m, d.count || 0), 0);
      const points = this.data
        .filter(d => DAY_ORDER.indexOf(d.dayOfWeek) !== -1)
        .map(d => [d.hour, DAY_ORDER.indexOf(d.dayOfWeek), d.count || 0]);
      return {
        tooltip: {
          position: "top",
          formatter(params) {
            const [hour, dayIdx, count] = params.value;
            return DAY_ORDER[dayIdx] + " " + hour + ":00<br/>" + (count || 0).toLocaleString() + " requests";
          }
        },
        grid: { left: 70, right: 20, top: 10, bottom: 60 },
        xAxis: {
          type: "category",
          data: HOURS.map(h => h + ":00"),
          splitArea: { show: true },
          axisLabel: { color: "#9aa5b1", fontSize: 11, interval: 1 }
        },
        yAxis: {
          type: "category",
          data: DAY_ORDER,
          splitArea: { show: true },
          axisLabel: { color: "#606266", fontSize: 12 }
        },
        visualMap: {
          min: 0,
          max: max || 1,
          calculable: true,
          orient: "horizontal",
          left: "center",
          bottom: 0,
          inRange: { color: ["#eef2ff", "#5b8ff9", "#1d39c4"] }
        },
        series: [
          {
            type: "heatmap",
            data: points,
            itemStyle: { borderColor: "#fff", borderWidth: 1 }
          }
        ]
      };
    }
  }
};
</script>

<style scoped>
.heatmap-chart {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/auditLog/HeatmapChart.vue